// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/chevron.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u4D2jzA4ZiZ43J {
  position: relative;
  line-height: 10px;
  overflow: visible;
  white-space: nowrap;
  vertical-align: top;
}
.u4D2jzA4ZiZ43J.yTlodzTd9MqpOE {
  font-size: 8px;
}
.u4D2jzA4ZiZ43J.PIA3qfC7RKoBN4 {
  padding: unset;
  border: 0;
  border-radius: 100%;
}
.aGXi9buGLU8ael:hover {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  cursor: pointer;
}
.aGXi9buGLU8ael.V_PnoJ2AynVwLp {
  position: relative;
}
.aGXi9buGLU8ael.V_PnoJ2AynVwLp:hover::before {
  opacity: 0.2;
}
.aGXi9buGLU8ael.V_PnoJ2AynVwLp::before {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  border-radius: 50%;
  content: '';
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.D2w2y121IYmhCB {
  background-size: 100%;
  position: absolute;
  z-index: 3;
  right: 1px;
}
.D2w2y121IYmhCB {
  height: 9px;
  width: 9px;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.G6CmOLx93OUZez {
  background-color: transparent;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberAvatar": `u4D2jzA4ZiZ43J`,
	"longInitials": `yTlodzTd9MqpOE`,
	"clickableAvatar": `PIA3qfC7RKoBN4`,
	"hoverable": `aGXi9buGLU8ael`,
	"withImage": `V_PnoJ2AynVwLp`,
	"admin": `D2w2y121IYmhCB`,
	"transparentBackground": `G6CmOLx93OUZez`
};
export default ___CSS_LOADER_EXPORT___;
